import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import ForwardStepType, {
    ForwardStepTypeData,
    ForwardStepTypeDataKeys,
    ForwardStepTypeDisplayOptions,
} from '../../../../components/forward-step-type/ForwardStepType';

const ForwardStepTypeColumnTemplate = (props: CellTemplateProps) => {
    const data = gridCellData(props);
    return (
        <React.Fragment>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <ForwardStepType
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={props.data}
                        defaultProps={ForwardStepTypeColumnTemplateDefaultProps}
                    />
                )}
            </GridColumnInspectorHelper>
        </React.Fragment>
    );
};

export const ForwardStepTypeColumnTemplateDefaultProps = {} as ForwardStepTypeDisplayOptions;

export const ForwardStepTypeColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type ForwardStepTypeColumnTemplateData = ForwardStepTypeData & {};

export const ForwardStepTypeColumnTemplateDataKeys = [...ForwardStepTypeDataKeys];

export default ForwardStepTypeColumnTemplate;
